import React from 'react'
import { Stack, Chip, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { CardBlockInfo } from 'packages/ui/CardPreview'
import { getDeviceStatus, availableToTranslationKey, getDeviceColors, availableToColor } from '../../../helpers'
import DeviceIcon from './DeviceIcon'
import { ChildrenContainer, ChildrenTitle, ChildrenScrollContainer, ChildDeviceCard, InfoGrid } from './styles'

const DevicesList = ({ children }) => {
  const { t } = useTranslation()
  
  if (!children || children.length === 0) return null

  return (
    <ChildrenContainer>
      <ChildrenTitle>
        {t('supervision.card.child_devices')}
      </ChildrenTitle>
      <ChildrenScrollContainer>
        {children.map((child) => {
          const deviceColors = getDeviceColors(child)
          const childStatus = getDeviceStatus(child)
          
          let statusLevel = child.available_level || child.status || 'down'
          if (['hibernation', 'works'].includes(statusLevel)) {
            statusLevel = `${statusLevel}_${child.is_reachable ? 'up' : 'down'}`
          }
          const statusLabel = t(availableToTranslationKey(statusLevel))
          const statusColor = availableToColor(statusLevel)
          
          return (
            <ChildDeviceCard
              key={child.uuid}
              borderColor={statusColor}
              backgroundColor={deviceColors.default.bgcolor}
              sx={{
                borderWidth: '2px',
                borderStyle: 'solid'
              }}
            >
              <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 1 }}>
                <Stack direction="row" alignItems="center" gap={1}>
                  <DeviceIcon type={child.model?.type} device={child} size={24} />
                  <Stack direction="column">
                    <Typography fontSize={14} fontWeight={500}>
                      {child.label}
                    </Typography>
                    <Typography fontSize={12} fontWeight={400} color="text.secondary">
                      {statusLabel}
                    </Typography>
                  </Stack>
                </Stack>
                <Chip
                  label={child.model?.type?.toUpperCase()}
                  size="small"
                  sx={{
                    backgroundColor: deviceColors.default.bgcolor,
                    color: childStatus.color,
                    fontSize: 10,
                    height: 20,
                    fontWeight: 500
                  }}
                />
              </Stack>
              <InfoGrid>
                <CardBlockInfo
                  title={t('supervision.popup.manufacturer')}
                  subtitle={child.model?.manufacturer || '-'}
                />
                <CardBlockInfo
                  title={t('supervision.popup.model')}
                  subtitle={child.model?.name || '-'}
                />
                <CardBlockInfo
                  title={t('supervision.popup.mac_address')}
                  subtitle={child.mac || '-'}
                />
                <CardBlockInfo
                  title={t('supervision.popup.ip_address')}
                  subtitle={child.ip_address || '-'}
                />
              </InfoGrid>
            </ChildDeviceCard>
          )
        })}
      </ChildrenScrollContainer>
    </ChildrenContainer>
  )
}

export default DevicesList